import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../redux/settings/selectors";
import { selectCurrent as selectUserCurrent } from "../../../../redux/user/selectors";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../hooks/hooks";
import { user } from "../../../../redux/user/actions";
import useWindowDimensions from '../../../../hooks/useWindowsDimensions';
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import storePersist from "../../../../redux/storePersist";
import CustomerAccountSettings from "../../../../components/customer/AccountSettings";

const CustomerProfileMobile = () => {
	const navigate = useNavigate()
	const dispatch = useAppDispatch();
	const { register, handleSubmit, clearErrors, formState: { errors }, setValue } = useForm();
	const { height, width } = useWindowDimensions();
	const { theme } = useSelector(selectCurrent)
	const { isEditPersonalInfo } = useSelector(selectUserCurrent)
	const [color, setColor] = useState('universal')
	const [primary, setPrimary] = useState('#FFB934FF')
	const [secondary, setSecondary] = useState('#FFB934FF')
	const [steps, setSteps] = useState({})


	useEffect(() => {
		setColor(theme)
		if (theme == 'darkmode') {
			setPrimary('#f5e93cac')
			setSecondary('#ffffff')
		}
		else if (theme == 'lightmode') {
			setPrimary('#ffffffa2')
			setSecondary('#000000a2')
		}
		else if (theme == 'universal') {
			setPrimary('#233C64')
			setSecondary('#ffffff')
		}
		else if (theme == 'luxury') {
			setPrimary('#bd238c')
			setSecondary('#ffffff')
		}
		else if (theme == 'harmony') {
			setPrimary('#000000a2')
			setSecondary('#000000a2')
		}
		else if (theme == 'warmth') {
			setPrimary('#000000a2')
		}
	}, [theme]);

	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e.target.value })
	}

	const handleSave = () => {
		dispatch(user.set({ isEditPersonalInfo: false }))
	}
	const handleLogout = () => {
		localStorage.removeItem('access-token')
		localStorage.removeItem('accessTokenMetadata')
		localStorage.removeItem('userProfile')
		localStorage.removeItem('google-login-role')
		navigate('/auth/login/customer')
	}

	const userProfileData = storePersist?.get("userProfile")?.current;

	return (


		<div className={`max-h-screen`}>

			<div className="z-20 h-full py-10 overflow-y-auto ">
				<form onSubmit={handleSubmit(handleSave)} >
					<div className="w-full  rounded-lg  flex flex-col  text-black p-5">
						<div className="flex items-start justify-between w-full border-b p-2 border-blue-500">
							<div className="flex w-full flex-col items-start justify-between text-xl" >
								Personal Information
							</div>
							<div onClick={() => dispatch(user.set({ isEditPersonalInfo: true }))}>
								<svg className="w-6 h-6" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
									xmlns="http://www.w3.org/2000/svg">
									<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
									<path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
								</svg>
							</div>
						</div>
						<div className="flex w-full flex-col space-y-3 px-8 py-6 overflow-auto" >
							<div className="w-full">
								<label
									className="block w-full text-sm font-light mb-2" >
									First Name
								</label>
								<input
									type="text"
									disabled={!isEditPersonalInfo}
									{...register('firstName', { required: true, maxLength: 15 })}
									className="border-0 px-3 w-full py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
									placeholder="First Name"
									onChange={(e) => handleSteps(e, 'firstName')}
									defaultValue={userProfileData?.items[0]?.Message?.FirstName}
								/>
								{errors.firstName && errors.firstName.type === "required" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
								)}
								{errors.firstName && errors.firstName.type === "maxLength" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
								)}
							</div>
							<div className="w-full">
								<label
									className="block text-sm font-light mb-2" >
									Last Name
								</label>
								<input
									type="text"
									disabled={!isEditPersonalInfo}
									{...register('lastName', { required: true, maxLength: 30 })}
									className="border-0 w-full px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
									placeholder="Last Name"
									onChange={(e) => handleSteps(e, 'lastName')}
									defaultValue={userProfileData?.items[0]?.Message?.LastName}
								/>
								{errors.lastName && errors.lastName.type === "required" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
								)}
								{errors.lastName && errors.lastName.type === "maxLength" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">Max length exceeded</span>
								)}
							</div>
							<div className="w-full my-5">
								<label
									className="block w-full text-sm font-light mb-2" >
									Email Address*
								</label>
								<input
									type="text"
									disabled={!isEditPersonalInfo}
									{...register('emailAddress', {
										required: true,
										pattern:
											/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
									})}
									className="border-0 px-3 w-full py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
									placeholder="Email Address"
									onChange={(e) => handleSteps(e, 'emailAddress')}
									defaultValue={userProfileData?.items[0]?.Message?.Email}
								/>
								{errors.emailAddress && errors.emailAddress.type === "required" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
								)}
								{errors.emailAddress && errors.emailAddress.type === "pattern" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid email id</span>
								)}
							</div>
							<div className="w-full my-5">
								<label
									className="block text-sm font-light mb-2" >
									Phone*
								</label>
								<input
									type="text"
									disabled={!isEditPersonalInfo}
									{...register('Phone', {
										required: true,
										maxLength: 10,
										minLength: 10,
										pattern: /^[0-9+-]+$/
									})}
									className="border-0 w-full px-3 py-3 text-black rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
									placeholder="Phone"
									onChange={(e) => handleSteps(e, 'Phone')}
									defaultValue={userProfileData?.items[0]?.Message?.PhoneNumber}
								/>
								{errors.Phone && errors.Phone.type === "required" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs my-1">This is required</span>
								)}
								{errors.Phone && errors.Phone.type === "maxLength" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
								)}
								{errors.Phone && errors.Phone.type === "minLength" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
								)}
								{errors.Phone && errors.Phone.type === "pattern" && (
									<span role="alert" className="w-full text-red-500 bg-white text-xs  px-3">Please enter valid mobile number</span>
								)}
							</div>
						</div>
						{isEditPersonalInfo ? <div className="w-full flex text-center mt-6">
							<input type="submit"
								className="bg-red-500 text-white text-xl p-2 w-full"
								value='Update'
							/>
						</div> : <></>}
					</div>
				</form>
			</div>

		</div >


	)
}

export default CustomerProfileMobile

